<template>
  <p :class="classes">
    <slot></slot>
  </p>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import type { Weight, Size } from "./types";

export interface ParagraphProps {
  weight?: Weight;
  size?: Size;
}

const props = withDefaults(defineProps<ParagraphProps>(), {
  weight: "normal",
  size: "base",
});

const sizes = {
  xs: "tw-text-xs",
  sm: "tw-text-sm",
  base: "tw-text-base",
  lg: "tw-text-lg",
};

const weights = {
  thin: "tw-font-thin",
  extralight: "tw-font-extralight",
  light: "tw-font-light",
  normal: "tw-font-normal",
  medium: "tw-font-medium",
};

const classes = computed(() => {
  return [
    "cl-p tw-mb-3 tw-text-dorian-gray-500",
    sizes[props.size],
    weights[props.weight],
  ];
});
</script>

<style scoped></style>
